module.exports = __webpack_public_path__ + "static/media/Attendance.de532ef6.svg";